import { DetailsCollapsableSectionDesktop } from './desktop';
import { DetailsCollapsableSectionMobile } from './mobile';
type CollapsableSectionProps = {
   title: React.ReactNode;
   children: React.ReactNode;
};
export const DetailsCollapsableSection = (props: CollapsableSectionProps) => {
   return (
      <div>
         <div className="hidden tablet:block">
            <DetailsCollapsableSectionDesktop {...props} />
         </div>
         <div className="tablet:hidden">
            <DetailsCollapsableSectionMobile {...props} />
         </div>
      </div>
   );
};
